import type { BracketColor } from './types';

const COLORS: Record<BracketColor, string> = {
  amber: '#F59E0B',
  pink: '#EC4899',
  blue: '#3B82F6',
};

export function CornerBrackets({ color }: { color: BracketColor }) {
  const c = COLORS[color];
  const stroke = 4;
  const len = 28;
  return (
    <div className="pointer-events-none absolute inset-0">
      <svg className="absolute top-4 left-4" width={len} height={len}>
        <path d={`M 0 ${len} L 0 0 L ${len} 0`} fill="none" stroke={c} strokeWidth={stroke} />
      </svg>
      <svg className="absolute top-4 right-4" width={len} height={len}>
        <path d={`M ${len} ${len} L ${len} 0 L 0 0`} fill="none" stroke={c} strokeWidth={stroke} />
      </svg>
      <svg className="absolute bottom-4 left-4" width={len} height={len}>
        <path d={`M 0 0 L 0 ${len} L ${len} ${len}`} fill="none" stroke={c} strokeWidth={stroke} />
      </svg>
      <svg className="absolute bottom-4 right-4" width={len} height={len}>
        <path d={`M 0 ${len} L ${len} ${len} L ${len} 0`} fill="none" stroke={c} strokeWidth={stroke} />
      </svg>
    </div>
  );
}
